import type { MusicaRaioX, CartaoRaioX } from '@/shared/types';

/**
 * Decide quais cartões a faixa de RAIO-X exibe.
 *
 * Cartão sem dado é pulado, não renderizado vazio — nem toda faixa tem álbum,
 * gênero, gravadora ou BPM, e o provedor que responde muda quais campos vêm.
 */
export function montarCartoesRaioX(dados: MusicaRaioX): CartaoRaioX[] {
  if (!dados.encontrado) return [];

  const cartoes: CartaoRaioX[] = [];

  if (dados.artista) {
    cartoes.push({ id: 'artista', principal: dados.artista, secundario: dados.faixa });
  }

  if (dados.album) {
    cartoes.push({
      id:         'album',
      principal:  dados.album,
      secundario: dados.ano !== null ? String(dados.ano) : null,
    });
  }

  const extras: string[] = [];
  if (dados.genero)    extras.push(dados.genero);
  if (dados.gravadora) extras.push(dados.gravadora);
  if (dados.bpm)       extras.push(`${dados.bpm} BPM`);

  if (extras.length > 0) {
    cartoes.push({
      id:         'extra',
      principal:  extras[0],
      secundario: extras.length > 1 ? extras.slice(1).join(' · ') : null,
    });
  }

  return cartoes;
}
